"use client";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useEffect, useRef, useState } from "react";
import useFilterStore from "@store/browseJobsFiltersStore";
import { useIntl } from "react-intl";

import useJobLoadingStore from "@store/isLoadingJobs";
import Checkbox from "@components/Forms/Checkbox";

const DatesFilter = () => {
  const { setIsLoading }: any = useJobLoadingStore();

  const intl = useIntl();
  const translation = intl.messages;
  const jobsTranslation: any = translation["jobs"];
  const FiltersTranslation: any = jobsTranslation["filters"];

  const Dates = [
    { label: "This Week" },
    { label: "Last Week" },
    { label: "This Month" },
    { label: "Over a Month" },
  ];

  const { dateFilters, addDateFilter, clearDateFilters } = useFilterStore();

  const [isOpen, setIsOpen] = useState(true);

  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  }, [isOpen]);

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    addDateFilter(value);
    setIsLoading(true);
  };

  const toggleFilterVisibility = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="pt-5 mt-5">
      <button
        className="flex justify-between items-center w-full py-1"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-sm lg:text-[15px] font-medium text-[#1F2223]">
          {FiltersTranslation["date-posted"]}
        </span>

        <ChevronDownIcon
          className={`w-5 h-5 transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      <div
        ref={contentRef}
        style={{ maxHeight: height }}
        className={`flex flex-col w-full overflow-hidden transition-max-height duration-500 ease-in-out`}
      >
        <div className="px-4 mt-5">
          <ul className="w-full flex flex-col gap-4">
            {Dates.map((date: any) => (
              <li key={date.label}>
                <label className="font-medium text-sm text-[#444748] flex items-center gap-3">
                  <Checkbox
                    type="radio" // Changed to radio
                    value={date.label}
                    checked={dateFilters === date.label} // Single selection
                    onChange={handleRadioChange}
                    className="border border-[#E0E0E0] focus:ring-transparent w-[18px] h-[18px] rounded-[5px] mr-[5px] delay-[500] focus:bg-[#4dbfda] cursor-pointer checked:bg-[#4dbfda]"
                  />
                  <span>{date.label}</span>
                </label>
              </li>
            ))}
          </ul>

          <div className="flex flex-row items-center justify-end w-full">
            <button
              className="font-normal text-[12px] text-[#4DBFDA]"
              onClick={clearDateFilters}
            >
              {FiltersTranslation["clear"]}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatesFilter;
